const builtInVoxelReductions = {
    None: 'none',
    BoxAverage: 'boxAverage',
    BoxForegroundMajority: 'boxForegroundMajority',
    Decimation: 'decimation',
};
const VoxelReductions = builtInVoxelReductions;
export function registerVoxelReductionsConstant(name, reduction) {
    if (Object.prototype.hasOwnProperty.call(VoxelReductions, name)) {
        throw new Error(`Voxel reduction constant "${String(name)}" already exists`);
    }
    VoxelReductions[name] =
        reduction;
}
export default VoxelReductions;
